// 회원가입 3단계와 마이페이지 사업자 정보 카드가 같은 규칙으로 사업자등록증을 받는다.
// 서버가 받는 파일 형식·용량이며, 화면의 안내 문구도 이 값과 같은 기준이다.
export const BUSINESS_REGISTRATION_CERTIFICATE_ACCEPT =
  "application/pdf,image/jpeg,image/png";

const ACCEPTABLE_TYPES = ["application/pdf", "image/jpeg", "image/png"];

export const MAX_BUSINESS_REGISTRATION_CERTIFICATE_FILE_SIZE = 10 * 1024 * 1024;

export function isAcceptableBusinessRegistrationCertificateType(file: File) {
  return ACCEPTABLE_TYPES.includes(file.type);
}

export const BUSINESS_REGISTRATION_NUMBER_PATTERN = /^\d{3}-\d{2}-\d{5}$/;

// 사업자등록번호는 숫자 10자리를 XXX-XX-XXXXX 형식으로 노출한다.
// OCR 응답도 같은 형식이라, 사용자가 직접 고칠 때만 이 포맷터를 쓴다.
export function formatBusinessRegistrationNumber(raw: string) {
  const digits = raw.replace(/[^0-9]/g, "").slice(0, 10);
  if (digits.length < 4) {
    return digits;
  }
  if (digits.length < 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
}
